import type { TopClientRow, TopClientsReport } from "../api/topClients";

function escapeCsv(value: string | number | boolean | null | undefined): string {
  const text = value == null ? "" : String(value);
  if (/[",\n\r]/.test(text)) {
    return `"${text.replace(/"/g, '""')}"`;
  }
  return text;
}

function money(value: number | null | undefined): string {
  if (value == null || !Number.isFinite(value)) return "0.00";
  return value.toFixed(2);
}

const HEADERS = [
  "Rank",
  "Organization",
  "Client name",
  "Business name",
  "Legal name",
  "Code",
  "RIF",
  "Email",
  "Phone",
  "Mobile",
  "Office phone",
  "Address",
  "City",
  "Municipality",
  "Zone",
  "Fiscal address",
  "Shipping address",
  "Reference point",
  "Creator name",
  "Creator (raw)",
  "Assigned sales rep",
  "Responsible",
  "Customer type",
  "Sales zone",
  "Website",
  "Active",
  "Orders",
  "Revenue with tax",
  "Net revenue",
  "Avg order value",
  "Last order date",
  "Period from",
  "Period to",
] as const;

function rowToCells(
  row: TopClientRow,
  report: TopClientsReport
): Array<string | number> {
  return [
    row.rank,
    report.organizationName || "",
    row.clientName || "",
    row.businessName || "",
    row.legalName || "",
    row.clientCode || "",
    row.rif || "",
    row.email || "",
    row.phone || "",
    row.mobile || "",
    row.officePhone || "",
    row.address || "",
    row.city || "",
    row.municipality || "",
    row.zone || "",
    row.fiscalAddress || "",
    row.shippingAddress || "",
    row.referencePoint || "",
    row.creatorName || "",
    row.creatorSalesPerson || "",
    row.assignedSalesRepName || row.assignedSalesRep || "",
    row.responsible || "",
    row.customerType || "",
    row.salesZoneName || "",
    row.website || "",
    row.active == null ? "" : row.active ? "yes" : "no",
    row.orderCount,
    money(row.revenueWithTax),
    money(row.netRevenue),
    money(row.averageOrderValue),
    row.lastOrderDate || "",
    report.dateFrom,
    report.dateTo,
  ];
}

export function buildTopClientsExportFileName(report: TopClientsReport): string {
  const org = (report.organizationName || report.organizationId || "org")
    .replace(/\s+/g, "_")
    .replace(/[^\w.-]+/g, "");
  const from = report.dateFrom || "start";
  const to = report.dateTo || "end";
  return `top-clients_${org}_${from}_a_${to}.csv`;
}

/** UTF-8 CSV with BOM so Excel opens accents correctly. */
export function downloadTopClientsExcel(report: TopClientsReport): void {
  const lines = [
    HEADERS.join(","),
    ...report.clients.map((row) =>
      rowToCells(row, report).map(escapeCsv).join(",")
    ),
  ];
  const csv = `\uFEFF${lines.join("\n")}`;
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = buildTopClientsExportFileName(report);
  anchor.click();
  URL.revokeObjectURL(url);
}
